import { RadioButton } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
}

const EVKnowledge = ({ helper, optional }: Props) => {
  const name = 'ev_knowledge_rating'

  return (
    <div>
      <p className="my-5">
        How would you rate your understanding of Battery Electric cars?
        {optional && (
          <span className="text-xs lowercase whitespace-nowrap">
            {' '}
            (optional)
          </span>
        )}
      </p>
      {helper && <p className="text-sm text-gray-600 mb-3">{helper}</p>}
      <div className="inline-block">
        <div className="radio-btn-container flex gap:0 sm:gap-4 md:gap-14 mb-2">
          <RadioButton
            name={name}
            label="1"
            value="1"
            errorDisabled={optional}
          />
          <RadioButton
            name={name}
            label="2"
            value="2"
            errorDisabled={optional}
          />
          <RadioButton
            name={name}
            label="3"
            value="3"
            errorDisabled={optional}
          />
          <RadioButton
            name={name}
            label="4"
            value="4"
            errorDisabled={optional}
          />
          <RadioButton
            name={name}
            label="5"
            value="5"
            errorDisabled={optional}
          />
        </div>
        <div className="flex justify-between text-xs text-gray-600 mb-5">
          <span>No knowledge</span>
          <span>Very knowledgeable</span>
        </div>
      </div>
    </div>
  )
}

export default EVKnowledge
